import Coordinate from "../shapes/support/Coordinate";
import AbstractProvidedClass from "../shared/AbstractProvidedClass";

export default class View extends AbstractProvidedClass {
    maxScale = 10;
    minScale = 0.005;
    zoomFactor = 1.2;
    posX = 120;
    posY = 120;
    scale = 1;

    init({ scale = 1, posX = 120, posY = 120 } = {}) {
        this.scale = scale;
        this.posX = posX;
        this.posY = posY;
    }

    reset() {
        this.scale = 1;
        this.posX = 120;
        this.posY = 120;

        this.grid.recalculate();
    }

    zoomIn(mPosX, mPosY, zoomFactor = this.zoomFactor) {
        if (this.scale >= this.maxScale) {
            return;
        }

        this.scale *= zoomFactor;
        this.posX = Math.round(this.posX * zoomFactor
            - (mPosX ?? this.p.width / 2) * (zoomFactor - 1));
        this.posY = Math.round(this.posY * zoomFactor
            - (mPosY ?? this.p.height / 2) * (zoomFactor - 1));

        this.grid.recalculate();
        this.store();
    }

    zoomOut(mPosX, mPosY, zoomFactor = this.zoomFactor) {
        if (this.scale <= this.minScale) {
            return;
        }

        this.scale /= zoomFactor;
        this.posX = Math.round((
            this.posX + (mPosX ?? this.p.width / 2) * (zoomFactor - 1)
        ) / zoomFactor);
        this.posY = Math.round((
            this.posY + (mPosY ?? this.p.height / 2) * (zoomFactor - 1)
        ) / zoomFactor);

        this.grid.recalculate();
        this.store();
    }

    move(xMovement, yMovement) {
        this.posX += Math.round(xMovement);
        this.posY += Math.round(yMovement);
        this.store();
    }

    getRelative(x, y, rotation) {
        let d = this.p.dist(this.currentX, this.currentY, x, y);
        let a = Math.atan2(this.currentY - y, this.currentX - x);
        return [d * Math.cos(a - rotation), d * Math.sin(a - rotation), a, d];
    }

    get snappedAbsX() {
        return Math.round(this.snappedRelX / this.scale);
    }

    get snappedAbsY() {
        return Math.round(this.snappedRelY / this.scale);
    }

    get snappedRelX() {
        return this.settings.snapToGrid
            ? Math.round(this.currentX / this.grid.minorSize) * this.grid.minorSize
            : Math.round(this.currentX);
    }

    get snappedRelY() {
        return this.settings.snapToGrid
            ? Math.round(this.currentY / this.grid.minorSize) * this.grid.minorSize
            : Math.round(this.currentY);
    }

    get absX() {
        return Math.round(this.currentX / this.scale);
    }

    get absY() {
        return Math.round(this.currentY / this.scale);
    }

    get currentX() {
        return this.p.mouseX - this.posX;
    }

    get currentY() {
        return this.p.mouseY - this.posY;
    }

    get snappedCoordinate() {
        return new Coordinate(this.provider, this.snappedAbsX, this.snappedAbsY);
    }

    get coordinate() {
        return new Coordinate(this.provider, this.absX, this.absY);
    }

    export() {
        return { scale: this.scale, posX: this.posX, posY: this.posY };
    }

    store() {
        if (this.storage) {
            this.storage.save();
        }
    }
}
